export enum AccountManagementFeatureFlags {
    EnableNovaPhysicalUnitsCostCenters = 'enable-nova-physical-units-cost-centers',
    EnableNovaNewCostCentersGrid = 'enable-nova-new-cost-centers-grid',
    UnitVersePhysicalUnitParent = 'unit-verse-physical-unit-parent',
    EnablePhysicalUnitEditLinkingErrorFlow = 'enable-physical-unit-edit-linking-error-flow',
    EnablePhysicalUnitLinkingOnCancelRemoval = 'enable-physical-unit-linking-on-cancel-removal',
    DefaultCreatePhysicalUnitFlowLinkedUD = 'default-create-physical-unit-flow-linked-ud',
    EnablePhysicalUnitsFacilityAPI = 'enable-physical-units-facility-api',
    EnablePhysicalUnitFacilityEditing = 'enable-physical-unit-facility-editing',
    EnablePhysicalUnitNamingValidation = 'enable-physical-unit-naming-validation',
    AddAccountFilterToPhysicalUnitsGrid = 'add-account-filter-to-physical-units-grid',
    AddMyUnitsFilterToPhysicalUnitsGrid = 'add-my-units-filter-to-physical-units-grid',
    AddPhysicalUnitsDeptsDetailsPage = 'add-physical-units-depts-details-page',
    PhysicalUnitSaveAfterUnarchiveFix = 'physical-unit-save-after-unarchive-fix',
    EnableCostCenterLegacyUdLinking = 'enable-cost-center-legacy-ud-linking',
    EnableJobDetailPhysicalUnitCostCenter = 'enable-job-detail-physical-unit-cost-center',
    AddUnitLinkToFacilityContacts = 'add-unit-linking-to-facility-contacts',
    EnableFloatPoolPhysicalUnits = 'enable-float-pool-physical-units',
    OnePhysicalUnitPerCostCenter = 'one-physical-unit-per-cost-center',
    AddUdManagementUnderPhysicalUnit = 'add-ud-management-under-physical-unit',
    CostCenterNameNonEmpty = 'cost-center-name-non-empty',
    EnableArchiveWithoutUdLinking = 'enable-archive-without-ud-linking',
    EnablePhysicalUnitEligibleFacilitiesTreeSync = 'enable-physical-unit-eligible-facilities-tree-sync',
    EnableEditPhysicalUnitCcLinkedReadOnlyFix = 'enable-edit-physical-unit-cc-linked-read-only-fix'
}
